import { render, staticRenderFns } from "./internal-issue.vue?vue&type=template&id=2a5d7d68"
import script from "./internal-issue.vue?vue&type=script&lang=js"
export * from "./internal-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports